import { render, staticRenderFns } from "./bip-list.vue?vue&type=template&id=246321f2&scoped=true&"
import script from "./bip-list.vue?vue&type=script&lang=ts&"
export * from "./bip-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246321f2",
  null
  
)

export default component.exports